import Phaser from 'phaser';
import TaskScene from '../scene/TaskScene';

export const config: Phaser.Types.Core.GameConfig = {
  type: Phaser.AUTO,
  // backgroundColor: '#555555',
  transparent: true,
  scale: {
    parent: 'client-task-container',
    mode: Phaser.Scale.RESIZE,
    autoCenter: Phaser.Scale.CENTER_BOTH,
    width: window.innerWidth,
    height: window.innerHeight,
  },
  scene: [new TaskScene('therapist')],
  banner: false,
};
